import dayjs from 'dayjs';
import {getParams, isInApp} from "@/common/utils/tools";
import {getUserInformation} from '@/service/api';

interface SenseUserInfo {
    phone?: string;
    birthday?: string;
    birthday_timestamp?: string | number;
    has_activated_client?: boolean;
    created_time?: number;
    level?: string | number;
    uid?: string | number;
    string_uc_uid?: string | number;
}

export class Sense {
    static initPromise

    static init(options) {
        this.initPromise = this.initSense(options);
        return this.initPromise;
    }

    private static async initSense({product_id, app_id, app_version, other_attr = {}}) {
        const {sense, mmc} = (window as any);
        if (!sense) return;

        if (isInApp()) {
            if (!mmc.afterReady) {
                await new Promise(resolve => {
                    mmc.ready(resolve);
                });
            }
        }

        const channel = getParams('channel') || localStorage.getItem('channel') || '';
        const object: any = {
            app_id:app_id|| 'S49', // 业务线id
            product_id:product_id|| '159714467600000010',
            channel, // 渠道号
            single_page: true, // 是否单页应用
            attr: {
                $app_version:app_version|| 'H5-live',
                ...other_attr,
            },
            auto_track: true,
            user_center_id: getParams('u_id') || '1',
            show_log: false // 发送数据时，是否在控制台显示日志信息
            // env: "", // 环境 台湾 tw 美国 mx
        };

        let userInfo: SenseUserInfo = {};
        if (localStorage.getItem('tToken')) {
            try {
                userInfo = await getUserInformation() as SenseUserInfo;
                localStorage.setItem('user_info', JSON.stringify({
                    phone: userInfo.phone || '',
                    birthday: userInfo.birthday || '',
                    birthday_timestamp: userInfo.birthday_timestamp == null
                        ? ''
                        : userInfo.birthday_timestamp,
                    has_activated_client: userInfo.has_activated_client,
                }));

                const registerDay = dayjs().diff(dayjs(userInfo.created_time * 1000), 'day', true);
                object.attr = {
                    ...object.attr,
                    is_new: registerDay < 3,
                    grade: userInfo.level || '',
                    extend_3: userInfo.uid || '',
                };
            } catch (error) {
                console.error(error);
            }
        }

        sense._getUserID = function () {
            return userInfo.uid || '1'; // 未登录时传 1
        };
        sense.init(object);
        sense.setUserCenterID(String(userInfo.string_uc_uid || getParams('u_id') || '1'));

        await new Promise(resolve => {
            function waitInit() {
                if (sense._status === 'fulfill') {
                    resolve();
                    return;
                }
                setTimeout(waitInit, 100);
            }

            waitInit();
        });
    }

    static async track(eventName, properties = {}) {
        const {sense} = window as any;

        await this.initPromise;

        return sense.track(eventName, {
            source: location.href,
            ...properties,
        });
    }
}
